var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-checked-out"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked-out",
    clipPath: "url(#clip-checked-out)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32865",
    "data-name": "Group 32865",
    transform: "translate(-3315.865 13492.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11154",
    "data-name": "Ellipse 11154",
    transform: "translate(3315.865 -13492.611)",
    fill: "#efb36d",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35416",
    "data-name": "Rectangle 35416",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(3326.365 -13482.111)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedOut);
export default __webpack_public_path__ + "static/media/checked-out.81f1c43326580ec2811d631e174640a6.svg";
export { ForwardRef as ReactComponent };